export default "__VITE_ASSET__CX58h89i__"